import * as FlightCard from './components/FlightCard.module.css';
export default {
    FlightCard
};
